const moment = require("moment");

module.exports = Object.freeze({
    CALENDAR_INITIAL_EVENTS: [
        { title: "Product call", theme: "GREEN", startTime: moment().add(-12, 'd').startOf('day'), endTime: moment().add(-12, 'd').endOf('day') },
        { title: "Meeting with tech team", theme: "PINK", startTime: moment().add(-8, 'd').startOf('day'), endTime: moment().add(-8, 'd').endOf('day') },
        { title: "Meeting with Cristina", theme: "PURPLE", startTime: moment().add(-2, 'd').startOf('day'), endTime: moment().add(-2, 'd').endOf('day') },
        { title: "Meeting with Alex", theme: "BLUE", startTime: moment().startOf('day'), endTime: moment().endOf('day') },
        { title: "Product Call", theme: "GREEN", startTime: moment().startOf('day'), endTime: moment().endOf('day') },
        { title: "Client Meeting", theme: "PURPLE", startTime: moment().startOf('day'), endTime: moment().endOf('day') },
        { title: "Client Meeting", theme: "ORANGE", startTime: moment().add(3, 'd').startOf('day'), endTime: moment().add(3, 'd').endOf('day') },
        { title: "Product meeting", theme: "PINK", startTime: moment().add(5, 'd').startOf('day'), endTime: moment().add(5, 'd').endOf('day') },
        { title: "Sales Meeting", theme: "GREEN", startTime: moment().add(8, 'd').startOf('day'), endTime: moment().add(8, 'd').endOf('day') },
        { title: "Product Meeting", theme: "ORANGE", startTime: moment().add(8, 'd').startOf('day'), endTime: moment().add(8, 'd').endOf('day') },
        { title: "Marketing Meeting", theme: "PINK", startTime: moment().add(8, 'd').startOf('day'), endTime: moment().add(8, 'd').endOf('day') },
        { title: "Client Meeting", theme: "GREEN", startTime: moment().add(8, 'd').startOf('day'), endTime: moment().add(8, 'd').endOf('day') },
        { title: "Sales meeting", theme: "BLUE", startTime: moment().add(12, 'd').startOf('day'), endTime: moment().add(12, 'd').endOf('day') },
        { title: "Client meeting", theme: "PURPLE", startTime: moment().add(16, 'd').startOf('day'), endTime: moment().add(16, 'd').endOf('day') },
    ],

    RECENT_TRANSACTIONS: [
        { name: "Alex", avatar: "https://reqres.in/img/faces/1-image.jpg", email: "alex@dashwind.com", location: "Paris", amount: 100, date: moment().endOf('day') },
        { name: "Ereena", avatar: "https://reqres.in/img/faces/2-image.jpg", email: "ereena@dashwind.com", location: "London", amount: 190, date: moment().add(-1, 'd').endOf('day') },
        { name: "John", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "jhon@dashwind.com", location: "Canada", amount: 112, date: moment().add(-1, 'd').endOf('day') },
        { name: "Matrix", avatar: "https://reqres.in/img/faces/4-image.jpg", email: "matrix@dashwind.com", location: "Peru", amount: 111, date: moment().add(-1, 'd').endOf('day') },
        { name: "Virat", avatar: "https://reqres.in/img/faces/5-image.jpg", email: "virat@dashwind.com", location: "London", amount: 190, date: moment().add(-2, 'd').endOf('day') },
        { name: "Miya", avatar: "https://reqres.in/img/faces/6-image.jpg", email: "miya@dashwind.com", location: "Paris", amount: 230, date: moment().add(-2, 'd').endOf('day') },
        { name: "Virat", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "virat@dashwind.com", location: "Canada", amount: 331, date: moment().add(-2, 'd').endOf('day') },
        { name: "Matrix", avatar: "https://reqres.in/img/faces/1-image.jpg", email: "matrix@dashwind.com", location: "London", amount: 581, date: moment().add(-2, 'd').endOf('day') },
        { name: "Ereena", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "ereena@dashwind.com", location: "Tokyo", amount: 151, date: moment().add(-2, 'd').endOf('day') },
        { name: "John", avatar: "https://reqres.in/img/faces/2-image.jpg", email: "jhon@dashwind.com", location: "Paris", amount: 91, date: moment().add(-2, 'd').endOf('day') },
        { name: "Virat", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "virat@dashwind.com", location: "Canada", amount: 161, date: moment().add(-3, 'd').endOf('day') },
        { name: "Matrix", avatar: "https://reqres.in/img/faces/4-image.jpg", email: "matrix@dashwind.com", location: "US", amount: 121, date: moment().add(-3, 'd').endOf('day') },
        { name: "Ereena", avatar: "https://reqres.in/img/faces/6-image.jpg", email: "jhon@dashwind.com", location: "Tokyo", amount: 713, date: moment().add(-3, 'd').endOf('day') },
        { name: "John", avatar: "https://reqres.in/img/faces/2-image.jpg", email: "ereena@dashwind.com", location: "London", amount: 217, date: moment().add(-3, 'd').endOf('day') },
        { name: "Virat", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "virat@dashwind.com", location: "Paris", amount: 117, date: moment().add(-3, 'd').endOf('day') },
        { name: "Miya", avatar: "https://reqres.in/img/faces/7-image.jpg", email: "jhon@dashwind.com", location: "Canada", amount: 612, date: moment().add(-3, 'd').endOf('day') },
        { name: "Matrix", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "matrix@dashwind.com", location: "London", amount: 631, date: moment().add(-3, 'd').endOf('day') },
        { name: "Virat", avatar: "https://reqres.in/img/faces/2-image.jpg", email: "ereena@dashwind.com", location: "Tokyo", amount: 151, date: moment().add(-3, 'd').endOf('day') },
        { name: "Ereena", avatar: "https://reqres.in/img/faces/3-image.jpg", email: "virat@dashwind.com", location: "Paris", amount: 617, date: moment().add(-3, 'd').endOf('day') },


    ],

    DUMMY_CARD_QUESTION: {
        answer: '',
        answerHighlightArr: [],
        default: [],
        followupQnas: [],
        isFavourite: true,
        noOfPractices: 0,
        question: '',
        savedAt: '',
        _id: ''
    },

    TARGET_COMPANIES: [{ name: "Apple" },
    { name: "Microsoft" },
    { name: "Amazon" },
    { name: "Google" },
    { name: "Meta" },
    { name: "Walmart" },
    { name: "ExxonMobil" },
    { name: "JPMorgan Chase" },
    { name: "Johnson & Johnson" },
    { name: "Visa" },
    { name: "Procter & Gamble" },
    { name: "AT&T" },
    { name: "Coca-Cola" },
    { name: "Disney" },
    { name: "Netflix" },
    { name: "Nike" },
    { name: "McDonald's" },
    { name: "Toyota" },
    { name: "Intel" },
    { name: "Mastercard" },
    { name: "Verizon" },
    { name: "IBM" },
    { name: "Boeing" },
    { name: "Chevron" },
    { name: "Cisco" },
    { name: "Pepsi" },
    { name: "Adobe" },
    { name: "General Electric" },
    { name: "Home Depot" },
    { name: "FedEx" },
    { name: "Oracle" },
    { name: "Starbucks" },
    { name: "Comcast" },
    { name: "UPS" },
    { name: "Goldman Sachs" },
    { name: "Morgan Stanley" },
    { name: "American Express" },
    { name: "3M" },
    { name: "Salesforce" },
    { name: "Pfizer" },
    { name: "Merck" },
    { name: "Nvidia" },
    { name: "PayPal" },
    { name: "Accenture" },
    { name: "Costco" },
    { name: "Qualcomm" },
    { name: "Abbott Laboratories" },
    { name: "Citigroup" },
    { name: "Sony" },
    { name: "Samsung" },
    { name: "BMW" },
    { name: "Honda" },
    { name: "Ford" },
    { name: "General Motors" },
    { name: "Tesla" },
    { name: "Uber" },
    { name: "Airbnb" },
    { name: "X (Twitter)" },
    { name: "LinkedIn" },
    { name: "Dell" },
    { name: "HP" },
    { name: "Adidas" },
    { name: "Siemens" },
    { name: "Volkswagen" },
    { name: "Nestle" },
    { name: "Unilever" },
    { name: "L'Oreal" },
    { name: "LVMH" },
    { name: "Gucci" },
    { name: "Zara" },
    { name: "H&M" },
    { name: "Target" },
    { name: "Lowe's" },
    { name: "Best Buy" },
    { name: "eBay" },
    { name: "Spotify" },
    { name: "Alibaba" },
    { name: "Tencent" },
    { name: "Baidu" },
    { name: "Shell" },
    { name: "BP" },
    { name: "Total" },
    { name: "Philips" },
    { name: "Canon" },
    { name: "Panasonic" },
    { name: "LG" },
    { name: "Huawei" },
    { name: "Xiaomi" },
    { name: "Lenovo" },
    { name: "Ericsson" },
    { name: "Nokia" },
    { name: "Vodafone" },
    { name: "T-Mobile" },
    { name: "Sprint" },
    { name: "Deloitte" },
    { name: "KPMG" },
    { name: "PwC" },
    { name: "Ernst & Young" },
    { name: "McKinsey & Company" },
    { name: "BlackRock" },
    { name: "Berkshire Hathaway" },
    { name: "Wells Fargo" },
    { name: "Bank of America" },
    { name: "HSBC" },
    { name: "Allianz" },
    { name: "AXA" },
    { name: "BNP Paribas" },
    { name: "UBS" },
    { name: "Credit Suisse" },
    { name: "Deutsche Bank" },
    { name: "Barclays" },
    { name: "Santander" },
    { name: "ING Group" },
    { name: "Prudential Financial" },
    { name: "MetLife" },
    { name: "Charles Schwab" },
    { name: "State Street" },
    { name: "Fidelity Investments" },
    { name: "Vanguard Group" },
    { name: "Capital One" },
    { name: "American International Group (AIG)" },
    { name: "Lloyds Banking Group" },
    { name: "Royal Bank of Canada" },
    { name: "Toronto-Dominion Bank" },
    { name: "Scotiabank" },
    { name: "Standard Chartered" },
    { name: "Mitsubishi UFJ Financial Group" },
    { name: "Sumitomo Mitsui Financial Group" },
    { name: "Mizuho Financial Group" },
    { name: "Industrial and Commercial Bank of China (ICBC)" },
    { name: "China Construction Bank" },
    { name: "Agricultural Bank of China" },
    { name: "Bank of China" },
    { name: "DBS Bank" },
    { name: "OCBC Bank" },
    { name: "United Overseas Bank" },
    { name: "Nomura Holdings" },
    { name: "Société Générale" },
    { name: "Crédit Agricole" },
    { name: "Natixis" },
    { name: "Intesa Sanpaolo" },
    { name: "UniCredit" },
    { name: "Banco Bilbao Vizcaya Argentaria (BBVA)" },
    { name: "Nordea" },
    { name: "Danske Bank" },
    { name: "DNB" },
    { name: "Zurich Insurance Group" },
    { name: "Swiss Re" },
    { name: "Ping An Insurance" },
    { name: "Shopify" },
    { name: "Etsy" },
    { name: "Wayfair" },
    { name: "Chewy" },
    { name: "Overstock" },
    { name: "Wish" },
    { name: "Rakuten" },
    { name: "JD.com" },
    { name: "Pinduoduo" },
    { name: "Flipkart" },
    { name: "Zalando" },
    { name: "ASOS" },
    { name: "Farfetch" },
    { name: "Noon" },
    { name: "Lazada" },
    { name: "Shopee" },
    { name: "Mercado Libre" },
    { name: "Coupang" },
    { name: "Jumia" },
    { name: "Newegg" },
    { name: "Zappos" },
    { name: "Booking.com" },
    { name: "Expedia" },
    { name: "Priceline" },
    { name: "Trivago" },
    { name: "Hotels.com" },
    { name: "Groupon" },
    { name: "Instacart" },
    { name: "DoorDash" },
    { name: "Grubhub" },
    { name: "Uber Eats" },
    { name: "Deliveroo" },
    { name: "Just Eat" },
    { name: "Wix" },
    { name: "Squarespace" },
    { name: "BigCommerce" },
    { name: "Magento (Adobe Commerce)" },
    { name: "WooCommerce" },
    { name: "Stripe" },
    { name: "Square" },
    { name: "Klarna" },
    { name: "Affirm" },
    { name: "Afterpay" },
    { name: "Blue Apron" },
    { name: "HelloFresh" },
    { name: "Rent the Runway" },
    { name: "StitchFix" },
    { name: "Warby Parker" },
    { name: "Dollar Shave Club" },
    { name: "Glossier" },
    { name: "Casper" },
    { name: "OpenAI" },
    { name: "DeepMind (Alphabet)" },
    { name: "IBM Watson" },
    { name: "Anthropic" },
    { name: "Palantir Technologies" },
    { name: "C3.ai" },
    { name: "DataRobot" },
    { name: "SenseTime" },
    { name: "Clarifai" },
    { name: "H2O.ai" },
    { name: "Dataiku" },
    { name: "Darktrace" },
    { name: "UiPath" },
    { name: "Blue Prism" },
    { name: "Automation Anywhere" },
    { name: "Scale AI" },
    { name: "Graphcore" },
    { name: "Cerebras Systems" },
    { name: "SambaNova Systems" },
    { name: "Hugging Face" },
    { name: "Anduril Industries" },
    { name: "Algolia" },
    { name: "Sentient Technologies" },
    { name: "Vicarious" },
    { name: "Petuum" },
    { name: "Diffbot" },
    { name: "Nuro" },
    { name: "Tempus" },
    { name: "Argo AI" },
    { name: "Aurora" },
    { name: "Cruise (GM)" },
    { name: "Waymo (Alphabet)" },
    { name: "Baidu AI" },
    { name: "iFlytek" },
    { name: "CloudMinds" },
    { name: "Face++" },
    { name: "Megvii" },
    { name: "Mobvoi" },
    { name: "DeepL" },
    { name: "Affectiva" },
    { name: "Cogito" },
    { name: "Primer AI" },
    { name: "Numerai" },
    { name: "Deepgram" },
    { name: "Labelbox" },
    { name: "Weights & Biases" },
    { name: "Cohere" },
    { name: "Moveworks" },
    { name: "Fiddler AI" },
    { name: "Databricks" },
    { name: "Slack" },
    { name: "Zoom" },
    { name: "Snowflake" },
    { name: "Twilio" },
    { name: "Atlassian" },
    { name: "Dropbox" },
    { name: "Box" },
    { name: "Okta" },
    { name: "DocuSign" },
    { name: "Splunk" },
    { name: "Workday" },
    { name: "ServiceNow" },
    { name: "Cloudflare" },
    { name: "Zendesk" }]
});
